import Vue from "vue";
const preventReClick = Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.style.pointerEvents = 'none';
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
          el.style.pointerEvents = 'auto';
        }, binding.value || 3000);
      }
    });
  }
});
export default preventReClick;